module.exports = __webpack_public_path__ + "img/declarations.e36c118a.svg";